import { viewModeEnum } from "@/enums/components/list";
export default {
  name: "ViewMode",
  emits: ['update:modelValue'],
  props: {
    modelValue: Number,
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(_props, {
    emit
  }) {
    const setViewMode = type => {
      emit('update:modelValue', type);
    };
    return {
      setViewMode,
      viewModeEnum
    };
  }
};